import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  input: '',
  size: 200,
  foregroundColor: '#000000',
  backgroundColor: '#ffffff',
  errorCorrectionLevel: 'M', // 'L', 'M', 'Q', 'H'
  outputRef: null,
}

const qrSlice = createSlice({
  name: 'qr',
  initialState,
  reducers: {
    setInput: (state, action) => {
      state.input = action.payload
    },
    setSize: (state, action) => {
      state.size = action.payload
    },
    setForegroundColor: (state, action) => {
      state.foregroundColor = action.payload
    },
    setBackgroundColor: (state, action) => {
      state.backgroundColor = action.payload
    },
    setErrorCorrectionLevel: (state, action) => {
      state.errorCorrectionLevel = action.payload
    },
    setOutputRef: (state, action) => {
      state.outputRef = action.payload
    },
    clearQrState: (state) => {
      state.input = ''
      state.outputRef = null
    },
  },
})

export const {
  setInput,
  setSize,
  setForegroundColor,
  setBackgroundColor,
  setErrorCorrectionLevel,
  setOutputRef,
  clearQrState,
} = qrSlice.actions

export default qrSlice.reducer
